/**
* RMKM Phase 2 Changes
* added by @ali 
* date : 14 April 2025
* Added new component attendance report to fetch staff login history
*  */
/**
 * RMKM new Implementation
 * @addedBy @ali-hussain
 * date : 12 September 2025
 * Implement the date filter and fixed the date format to DD-MM-YYYY
 */
/**
 * Added By jaseem
 * date : 09 September 2026
 * Attendance Report CSV download (same pattern as Student Registration List)
 */
import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions,
    TableBody,
    TableHeader
} from 'react-bs-datatable';
import inventoryApi from '../api/inventoryApi';
import moment from 'moment';
import { Link } from 'react-router-dom';
import DateRangePicker from "rsuite/DateRangePicker";
import "rsuite/DateRangePicker/styles/index.css";
import InfoPill from './InfoPill';
import csvDownload from "json-to-csv-export";

export default function UserTracking() {
    const [body, setBody] = useState([]);
    const [data, setData] = useState([]);
    const [dateRange, setDateRange] = useState([]);
    const [dateFiled, setDateFiled] = useState('logindatetime');
    const [header, setHeader] = useState([
        {
            title: 'Staff Name',
            prop: 'parent_name',
            // cell:(row)=>(<Link to={`/staffmembers/${row?.parentid}`}>{row?.parent_name}</Link>),
            isFilterable: true
        },
        {
            title: 'Check-in Date',
            prop: 'logindatetime',
            cell: (row) => row?.logindatetime ? moment(row.logindatetime).format('DD-MM-YYYY hh:mm A') : '',
            isFilterable: true
        },
        {
            title: 'Check-out Date',
            prop: 'logoutdatetime',
            cell: (row) => row?.logoutdatetime ? moment(row.logoutdatetime).format('DD-MM-YYYY hh:mm A') : '',
            isFilterable: true
        },
        {
            title: 'Location',
            prop: 'location',
            isFilterable: true
        },
        {
            title: 'Remarks',
            prop: 'remarks',
            isFilterable: true
        },
    ]);
    async function fetchData() {
        const result = await inventoryApi.fetchAllUserTrackingRec()
        if (Array.isArray(result)) {
            setBody(result);
            setData(result);
        } else {
            setBody([]);
            setData([]);
        }
    }
    useEffect(() => {
        fetchData();
    }, []);
    useEffect(() => {
        if (dateRange && dateRange.length > 0) {
            const startDate = moment(dateRange[0]).startOf('day');
            const endDate = moment(dateRange[1]).endOf('day');
            setBody(data.filter((item) => {
                if (item[dateFiled]) {
                    const itemDate = moment(item[dateFiled]);
                    return itemDate.isBetween(startDate, endDate, undefined, '[]'); // Inclusive range
                }
                return false;
            }));
        } else {
            setBody(data);
        }
    }, [dateRange, dateFiled]);
    const handleClear = () => {
        setDateRange([]);
        setBody(data);
    }

    // Added By jaseem — 09 September 2026 — CSV from currently filtered attendance rows
    const csvRows = (body || []).map((row) => ({
        'Staff Name': row?.parent_name || '',
        // 'Check-in Date': row?.logindatetime ? moment(row.logindatetime).format('DD-MM-YYYY') : '',
        // 'Check-out Date': row?.logoutdatetime ? moment(row.logoutdatetime).format('DD-MM-YYYY') : '',
        'Check-in Date': row?.logindatetime ? moment(row.logindatetime).format('DD-MM-YYYY HH:mm') : '',
        'Check-out Date': row?.logoutdatetime ? moment(row.logoutdatetime).format('DD-MM-YYYY HH:mm') : '',
        'Location': row?.location || '',
        'Remarks': row?.remarks || '',
    }));
    const ReportDataCSV =
        csvRows.length
            ? {
                data: csvRows,
                filename: 'Attendance Report',
                delimiter: ',',
                headers: Object.keys(csvRows[0] || {}),
            }
            : null;

    return (
        <Container>
            <DatatableWrapper body={body} headers={header} paginationOptionsProps={{
                initialState: {
                    rowsPerPage: 20,
                    options: [5, 10, 15, 20]
                }
            }}>
                <Row className='align-items-center'>
                    <Col md={3} className='pt-4'>
                        <Filter />
                    </Col>
                    <Col
                        md={1}
                    >
                        <PaginationOptions labels={{ beforeSelect: ' ' }} />
                    </Col>
                    <Col
                        md={2}
                        className='pt-4'
                    >
                        <Form.Select value={dateFiled} onChange={(e) => setDateFiled(e.target.value)}>
                            <option value={'logindatetime'}>Check-In Time</option>
                            <option value={'logoutdatetime'}>Check-Out Time</option>
                        </Form.Select>
                    </Col>
                    <Col md={3} className='pt-4'>
                        <DateRangePicker
                            value={dateRange}
                            onChange={(e) => {
                                setDateRange(e || []);
                            }}
                            // format="dd/mm/yyyy"
                            character=" – "
                        />
                    </Col>
                    <Col md={2} className='d-flex align-items-center gap-2 '>
                        <InfoPill left="Count" right={body?.length} />
                        {ReportDataCSV && (
                            <Button
                                className="btn-md mt-3"
                                variant="outline-success"
                                onClick={() => csvDownload(ReportDataCSV)}
                                title="Download CSV"
                            >
                                <i className="fa-solid fa-file-csv fs-5"></i>
                            </Button>
                        )}
                    </Col>


                    {/* <Col md={2}>
                        <Button onClick={handleClear} size='sm'>
                            <i className="fas fa-redo"></i>
                        </Button>
                    </Col> */}
                </Row>
                <Table striped className="mt-4 data-table">
                    <TableHeader />
                    <TableBody />
                </Table>
                <Pagination />

            </DatatableWrapper>
        </Container>
    )
}
